import { render, staticRenderFns } from "./MassStats.vue?vue&type=template&id=12cae706&"
import script from "./MassStats.vue?vue&type=script&lang=js&"
export * from "./MassStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports